import React from 'react'
import RehypeReact from 'rehype-react'
import {graphql} from 'gatsby'
import glamorous from 'glamorous'

import Default from '../layouts/default'
import Image from '../components/image'
import {H1} from '../components/common'

// Component remapping from HTML -> React glamorous components
import CustomComponents from './custom-components'

const FeatureImage = glamorous(Image)({})

const BlogPostTemplate = props => {
  const post = props.data.markdownRemark
  const pageContext = props.pageContext
  const images = pageContext.images

  const renderAst = new RehypeReact({
    createElement: React.createElement,
    components: CustomComponents({...props, images}),
  }).Compiler

  return (
    <Default title={pageContext.title} location={props.location} description={post.frontmatter.short}>
      <H1>{pageContext.title}</H1>
      <FeatureImage fluid={pageContext.featuredImage.childImageSharp.fluid} />

      {/* Inject Markdown HTML String into React Component */}
      {/* <div dangerouslySetInnerHTML={{__html: post.html}} /> */}
      {renderAst(post.htmlAst)}
    </Default>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    markdownRemark(fields: {slug: {eq: $slug}}) {
      id
      htmlAst
      frontmatter {
        short
      }
    }
  }
`
